import React, {Component} from 'react'

import {
    Spinner,
    css,
    Theme,
    Icon,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import {
    superadminGetOverallProjectsHealth,
    superadminGetProjectHealth,
} from "app/helpers/api";

import toastFactory from "app/helpers/toast_factory";
import {createToast} from "actions";

import {GENERAL_ERROR} from "template-edit/reducers";
import store from "store";
import {AxiosResponse} from "axios";
import Chart from "react-apexcharts";
import {ApexOptions} from "apexcharts";
import {ID} from "app/types/app-types";

export type ProjectHealthType = {
    projectId: number
    timeouted: number
    unsupportedMIMEType: number
    invalidStatusCode: number
    streamError:  number
}

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
}

type OverallProjectsHealthType = {
    series: DataItemType[]
    categories: ID[]
}


interface State {
    overallProjectsHealth: OverallProjectsHealthType
    projectHealth: ProjectHealthType
    loadedForProject: number
    isLoading: boolean
}

type DataItemType = {
    data: number[]
    name: string
}

class ProjectHealth extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isLoading: false,
            overallProjectsHealth: null,
            projectHealth: null,
            loadedForProject: null,
        }
    }

    getOverallProjectsHealth = () => {
        this.setState({isLoading: true})
        superadminGetOverallProjectsHealth()
            .then((response: AxiosResponse<OverallProjectsHealthType>) => {
                this.setState({overallProjectsHealth: response.data})
            })
            .catch(e => {
                console.error('cannot get overall project health', e)
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    getSelectedProjectHealth = () => {
        const {selectedProjectId, selectedTemplateId} = this.props
        this.setState({projectHealth: null, isLoading: true, loadedForProject: null})
        if (selectedProjectId) {
            superadminGetProjectHealth(selectedProjectId, selectedTemplateId)
                .then((response: AxiosResponse<ProjectHealthType[]>) => {
                    this.setState({projectHealth: response.data[0], loadedForProject: selectedProjectId})
                })
                .catch(e => {                    
                    console.error('cannot get project health', e)
                })
                .finally(() => {
                    this.setState({isLoading: false})
                })
        }
    }

    componentDidMount() {
        this.getSelectedProjectHealth()
        this.getOverallProjectsHealth()
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && prevProps.selectedProjectId !== this.props.selectedProjectId) {
            this.getSelectedProjectHealth()
        }
    }

    render() {
        const {isLoading, overallProjectsHealth, projectHealth, loadedForProject} = this.state
        const {selectedProjectId, selectedTemplateId} = this.props

        if (isLoading) {
            return <div>
                <Spinner type={'bubbles'}/>
            </div>
        }

        return (
            <StyledDiv>
                {overallProjectsHealth &&
                <div>
                    <h2>Overall projects health</h2>
                    {overallProjectsHealth.categories.length > 0 &&
                    <Chart
                        options={chartOptions(overallProjectsHealth)}
                        series={overallProjectsHealth.series}
                        type="bar"
                        height={400}
                    />
                    }
                </div>
                }

                {(selectedProjectId && loadedForProject === selectedProjectId) &&
                <div>
                    <h2>Selected project ({selectedProjectId}) health</h2>
                    {projectHealth ?
                        <StyledGrid cols={'max-content max-content'}>
                            <GridCell>Timeouted</GridCell><GridCell className={'right'}>{projectHealth.timeouted}</GridCell>
                            <GridCell>Invalid Status Code</GridCell><GridCell className={'right'}>{projectHealth.invalidStatusCode}</GridCell>
                            <GridCell>Unsupported MIME Type</GridCell><GridCell className={'right'}>{projectHealth.unsupportedMIMEType}</GridCell>
                        </StyledGrid> :
                        <div>
                            <Icon type={'check'} text={'No issues'} color={Theme.green} size={32} />
                        </div>
                    }
                </div>
                }
            </StyledDiv>
        )
    }
}

const StyledDiv = css('div')({
    margin: '20px 0 10px 0',
})

const StyledGrid = css(Grid)({
    padding: '10px',
    gridColumnGap: '20px',
    ' .right': {
        textAlign: 'right'
    }
})

const chartOptions = (chartData) : ApexOptions => ({
    series: chartData.series,
    chart: {
        type: 'bar',
        height: 400,
    },
    colors: [Theme.red, Theme.blue, Theme.steelblue, Theme.orange],
    dataLabels: {
        enabled: true,
        style: {
            colors: ['#fff']
        },
        dropShadow: {
            enabled: true
        }
    },
    xaxis: {
        categories: chartData.categories,
    },
})

export default ProjectHealth